/**
 * Form to input required test which must show up in the final generated tests
 * @param {object} parameters
 * @param {function} setParameters
 */
import Styles from './RequiredTests.module.scss'
import InputStyles from '../ParamsAndConstraints/ParamsAndConstrainsts.module.scss'
import React from 'react'

// component imports
import { useTranslation } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import FeatherIcon from 'feather-icons-react';

export function RequiredTests({ parameters, setParameters }) {

  const { t } = useTranslation();

  function addRequestedTests() {
    const newTest = {
      "name": "",
      "assigns": []
    }
    setParameters(prevState => ({
      ...prevState,
      requiredTests: [...parameters.requiredTests, newTest]
    }))
  }

  function editRequiredTests(param, value, objIndex, paramIndex) {

    setParameters(prevState => ({
      ...prevState,
      requiredTests: prevState.requiredTests.map((tests, index) => {
        if (index === objIndex) {
          const newTest = {
            param: param,
            value: value
          }
          tests.assigns[paramIndex] = newTest

        }
        return tests
      })
    }))
  }

  function deleteRequiredTests(objIndex) {
    const updatedReqTests = parameters.requiredTests.filter((_, index) => {
      return index !== objIndex
    })

    setParameters(prevState => ({
      ...prevState,
      requiredTests: updatedReqTests
    }))
  }

  return (
    <div className={Styles.parentContainer_reqTests}>
      <div className={Styles.header}>
        <p>{t('Components.NodeLayout.CombinatorialTestPane.requiredTests.title')}</p>
        <AivagamButton
          onClick={addRequestedTests}
          buttonText={
            <div style={{ display: 'flex', gap: '0.5em', height: '1em', alignItems: 'center' }}>
              <FeatherIcon size='1.5em' icon='plus-circle' />
              {t('Components.NodeLayout.CombinatorialTestPane.requiredTests.button.addReqTests')}
            </div>
          }
          classStyles={{ height: 'fit-content', marginLeft: 'auto' }}
          type='action'
        />
      </div>
      <div className={Styles.req_params_body}>
        {
          parameters.parameters.length ?
            <>
              <div className={Styles.req_tests_container}>
                {
                  parameters.requiredTests.map((reqTest, index) => (
                    <div key={`req_test_${index}`} className={Styles.req_tests_map}>
                      <span className={Styles.req_test_title_cont}>
                        <p className={Styles.req_test_title}>{t('Components.NodeLayout.CombinatorialTestPane.requiredTests.testTitle', { index: index + 1 })}</p>
                        <button title={t('Components.NodeLayout.CombinatorialTestPane.requiredTests.button.addVal')}><FeatherIcon size='1.1em' icon='x' color='red' role='button' onClick={() => { deleteRequiredTests(index) }} /></button>

                      </span>
                      <div className={Styles.select_req_params}>
                        {
                          parameters.parameters.map((params, paramIndex) => {
                            if (params?.key?.length) {
                              return (
                                <select
                                  key={`param_${paramIndex}`}
                                  className={`${InputStyles.parmaInput} ${Styles.paramSelect} `}
                                  onChange={(e) => {
                                    editRequiredTests(params.key, e.target.value, index, paramIndex)
                                  }}
                                  value={reqTest?.assigns?.[paramIndex]?.value}
                                >
                                  <option hidden>{params.key}</option>
                                  {
                                    params.values.map((val, valIndex) => {
                                      if (val?.length) {
                                        return (<option value={val} key={`value_${valIndex}`}>{val}</option>)
                                      } else {
                                        return null;
                                      }
                                    })
                                  }

                                </select>
                              )
                            } else {
                              return <span key={`param_${paramIndex}`}>Please add Param-{paramIndex + 1}</span>;
                            }
                          })
                        }
                      </div>
                    </div>
                  ))
                }
              </div>
              <AivagamButton
                onClick={addRequestedTests}
                buttonText={
                  <div style={{ display: 'flex', gap: '0.5em' }}>
                    <FeatherIcon size='1.5em' icon='plus-circle' />
                    {t('Components.NodeLayout.CombinatorialTestPane.requiredTests.button.addReqTests')}
                  </div>
                }
                classStyles={{ height: 'fit-content' }}
                type='action'
              />
            </> :
            <p className={Styles.warningText}><span style={{ color: 'red', marginRight: '0.2em' }}>*</span>{t('Components.NodeLayout.CombinatorialTestPane.requiredTests.alert.addParams')}</p>
        }
      </div>
    </div>
  )
}
